import Link from "next/link";
import SafeMarkdown from "components/ui/SafeMarkdown/SafeMarkdown";

import styles from "./LinkListItem.module.scss";

export default function LinkListItem({ item }) {
  return (
    <li className={`${styles.container}`}>
      <Link href={item.link} target={item.target} className={`${styles.link}`}>
        {item.name}
      </Link>
      {item.description && <SafeMarkdown>{item.description}</SafeMarkdown>}
    </li>
  );
}
